// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"25":"bb6730ac6abbf3a8","467":"bb6730ac6abbf3a8","888":"78385c2bb3776343","952":"bb6730ac6abbf3a8"}[chunkId] + ".css";
};